import {
  ONBOARDING_STEPS,
  type OnboardingStepKey,
  type OnboardingStatus,
} from './onboardingSteps';

/** Whether the user may navigate to target from current (client-side policy). */
export function canNavigateToStep(
  currentStep: string,
  targetStep: OnboardingStepKey,
  completedSteps: string[],
): boolean {
  if (targetStep === currentStep) {
    return false;
  }
  if (!ONBOARDING_STEPS.includes(targetStep)) {
    return false;
  }
  if (completedSteps.includes(targetStep)) {
    return true;
  }
  const currentIdx = ONBOARDING_STEPS.indexOf(currentStep as OnboardingStepKey);
  const targetIdx = ONBOARDING_STEPS.indexOf(targetStep);
  return currentIdx >= 0 && targetIdx >= 0 && targetIdx < currentIdx;
}

export function trimCompletedStepsBefore(
  completedSteps: string[],
  targetStep: OnboardingStepKey,
): string[] {
  const targetIdx = ONBOARDING_STEPS.indexOf(targetStep);
  if (targetIdx < 0) {
    return completedSteps;
  }
  return completedSteps.filter((s) => {
    const idx = ONBOARDING_STEPS.indexOf(s as OnboardingStepKey);
    return idx >= 0 && idx < targetIdx;
  });
}

/** Local fallback when visit API is unavailable (e.g. BFF not redeployed). */
export function applyLocalStepVisit(
  status: OnboardingStatus,
  targetStep: OnboardingStepKey,
): OnboardingStatus | null {
  if (!canNavigateToStep(status.currentStep, targetStep, status.completedSteps)) {
    return null;
  }
  return {
    ...status,
    currentStep: targetStep,
    completedSteps: trimCompletedStepsBefore(status.completedSteps, targetStep),
  };
}
